import RequestResetPassword from "./RequestResetPassword";
import ResetPassword from "./ResetPassword";
import useController from "./useController";

const Index = () => {
	const {
		code,
		handleCreateResetPasswordRequest,
		handleSubmitResetPasswordRequest,
		isInititalLoadingResetPasswordRequest,
		navigate,
		password,
		passwordValidationDetails,
		resetPasswordRequest,
		setPassword,
		submitError,
		validateNewPassword,
	} = useController();

	if (code) {
		return (
			<ResetPassword
				handleSubmitResetPasswordRequest={handleSubmitResetPasswordRequest}
				isInitialLoading={isInititalLoadingResetPasswordRequest}
				navigate={navigate}
				password={password}
				passwordValidationDetails={passwordValidationDetails}
				resetPasswordRequest={resetPasswordRequest}
				setPassword={setPassword}
				submitError={submitError}
				validateNewPassword={validateNewPassword}
			/>
		);
	} else {
		return (
			<RequestResetPassword
				handleCreateResetPasswordRequest={handleCreateResetPasswordRequest}
			/>
		);
	}
};

export default Index;
